import publicIP from 'react-native-public-ip';

export default async function GetIPAddress() {
    return await publicIP();
}